import React from 'react'
import styled from 'styled-components'
import { FontStyle, Text } from '~/components/core'
import { MangoButtonVariant } from '~/components/shared/componentStyles/MangoButton.style'
import { MangoButton } from '~/components/shared/MangoButton'
import { light } from '~/constants/theme'
import { colorPalette } from '~/themes/colors/colorPalette'
import { Environment } from '~/types/EnvironmentTypes'
import { Size } from '~/types/ThemeTypes'
import {
  buildEnvironment,
  getApiEnvironment,
  setApiEnvironment,
} from '~/utils/common'

import { toNounCasing } from '@mangovoice/core'

const EnvironmentToggleWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${light.blue200};
  padding: 12px;
  height: 80px;
  border-radius: 5px;
`

export const LoginEnvironmentToggle = () => {
  if (buildEnvironment === Environment.PRODUCTION) {
    return null
  }

  const api_env = getApiEnvironment()
  const toEnvironment =
    api_env === Environment.PRODUCTION
      ? Environment.STAGING
      : Environment.PRODUCTION
  const switchEnvironment = () => {
    setApiEnvironment(toEnvironment)
    window.location.reload()
  }

  return (
    <EnvironmentToggleWrapper>
      <Text
        align="center"
        fontStyle={FontStyle.bSmall}
        color={colorPalette.white}
      >
        {toNounCasing(api_env)} API Environment
      </Text>
      <MangoButton
        onClick={() => switchEnvironment()}
        variant={MangoButtonVariant.Default_300}
        size={Size.sm}
      >
        {`Switch to ${toNounCasing(toEnvironment)}`}
      </MangoButton>
    </EnvironmentToggleWrapper>
  )
}
